// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"5520c4c56caf10a6ec68","105":"475cd6d06997fefa1cdd","243":"b9e49f0c4364bb5ead67","682":"010d3484390bfdcb1778","688":"c7464210f6eab68ec885","765":"85e2cb3a12e4732aa483","852":"f8a01c5cdd9a263204a7"}[chunkId] + ".bundle.js";
};